import { AbstractControl, AsyncValidatorFn, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { catchError, delay, map, switchMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { Directive } from '@angular/core';

@Directive({
  selector: '[emailExistsAsyncValidator]',
  providers: [{ provide: NG_ASYNC_VALIDATORS, useExisting: EmailExistsAsyncValidator, multi: true }],
})
export class EmailExistsAsyncValidator {
  static createValidator(authService: AuthService): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      return of(control.value).pipe(
        delay(200),
        switchMap(a => {
          return authService.checkCustomerEmail(a).pipe(
            map(result => {
              return result;
            })
          );
        })
      );
    };
  }
}
